var panels = (function() {

    var $panelClose = $('.panel-header .panel-close');


    var panelCloseClick = function() {
        $panelClose.on('click', function(e) {
            e.preventDefault();
            $(this).closest('.panel').toggleClass('panel-closed');
        });
    };

    var init = function() {
        if($panelClose.length) {
            panelCloseClick();
        }
    };

    return {
        init: init
    };

})();

panels.init();



// WEBPACK FOOTER //
// ./library/js/modules/panels.js